$.view.addHelper({
	/**
	 * Output ISO date in human-friendly format
	 *
	 * @param {Boolean} [time=false]
	 * @param {Boolean} [year=true]
	 * @param {Boolean} [utc=false]
	 * @returns {String}
	 */
	dateFormat(time, year = true, utc = false) {
		return LS.util.dateFormat(this.val, time, year, utc);
	},

	/**
	 * Get date different in days
	 *
	 * @returns {Number}
	 */
	dayCount() {
		return LS.util.dayCount(this.val);
	},

	/**
	 * Format relative age
	 *
	 * @returns {String}
	 */
	dayFormat() {
		return LS.util.dayFormat(this.val);
	},

	/**
	 * Format seconds to HH:MM:SS
	 *
	 * @returns {String}
	 */
	timeFormat() {
		const val = this.val;
		const hours = Math.floor(val / 3600);
		const minutes = Math.floor((val - (hours * 3600)) / 60);
		const seconds = val - ((hours * 3600) + (minutes * 60));

		return (hours > 0 ? (hours < 10 ? '0' + hours : hours) + ':' : '') +
			(minutes < 10 ? '0' + minutes : minutes) + ':' +
			(seconds < 10 ? '0' + seconds : seconds);
	},
});